module.exports = __webpack_public_path__ + "img/IMG_1853.a59f54c7.jpg";